import React, { useEffect, useRef, useState } from "react";
import AppLayout from "../../../core/layouts/AppLayout";
import "../../../styles/listing.scss";

import Moment from "react-moment";
import moment from "moment";
import classnames from "classnames";
import {
  ListTable, ListHeader,
  Dict,
  FilterValueType,
  getFilters,
  PaginatedApiResponse,
  ListSort,
  SortOrder,
  QueryFilter,
  ListFilters,
  ListHeaderSearch,
  MultiSelectFilter,
  ListColumnSettings,
  SavedFilter,
  ListEntityType,
  Column, useLead,
  useConfiguration,
  PaidBy,
  SingleSelectFilter,
  City,
  DocumentCopyType,
  useHasPermission,
  AppPermissions
} from "../../../core";
import { State } from "../../../core/store/interfaces";
import { useMasterData } from "../../../core/hooks/useMasterData";
import api from "../../../api";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import { ContainerLoader } from "../../../components/loader";
import { useHistory, useLocation } from "react-router-dom";
import queryString, { ParsedQuery } from "query-string";

import DateRangeListFilter, {
  IDateRange,
} from "../../../core/components/list-filters/DateRangeListFilter";
import Pagination from "../../../core/components/pagination/Pagination";
import { toastr } from "react-redux-toastr";
import { LeadRequirement } from "../../../core/api/models/requirement";
import { IListTableColumnProps } from "../../../core/components/list-table/ListTableColumn";
import Tabs from "../Tabs";
import { documentStage, TabNames } from "../props";
import Requirement from "../../requirement/Requirement";
import { useSelector } from "react-redux";
import { decodeHtmlEntities } from "../../../utils/common";
import MainTabs from "../MainTabs";
import MultiSelectFilterWithApiSearch from "../../../core/components/list-filters/MultiSelectFilterWithApiSearch";
import UploadFeeDocument from "../../proposal/TermSheet/components/fee-confirmation/UploadFeeDocument";
import { FeeConfirmationTabNames } from "../../proposal/TermSheet/components/props";
import { ClientApproval, ClientInternalApproval, ClientRejected, ClientSigned, LandlordInternalApproval, Draft, LandlordApproval, LandlordSigned, LandlordRejected } from "./fee-letter-table-headings";
// import UploadFeeLetter from "../agreement/FeeLetter/components/UploadFeeLetter";

const FeeLetterList: React.FunctionComponent = () => {
  const history = useHistory();
  const params = useLocation().search;
  const masterData = useMasterData(api.settings);
  const canApproveFeeLetter = useHasPermission(AppPermissions.ApproveFeeLetter);
  const canRejectFeeLetter = useHasPermission(AppPermissions.RejectFeeLetter);
  const entityTypeName = useRef<ListEntityType>(ListEntityType.SpecialApprovalFeeLetterClientDraft);
  const [search, setSearch] = useState("");
  const [viewFeeLetterModal, setViewFeeLetterModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
    leadId?: string;
    isSigned?: boolean;
    title?: string;
    masterRequirementId?: string;
    stage?: string;
  }>({});

  const [filters, setFilters] = useState<Dict<FilterValueType>>({});

  const [tabName, setTabName] = useState<TabNames>(TabNames.draft);
  const [mainTabName, setMainTabName] = useState<DocumentCopyType | PaidBy>(DocumentCopyType.ClientCopy);
  const [propertyType, setPropertyType] = useState<any>([]);
  const [transactionExecutive, setTransactionExecutive] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);

  const { data: leadSettings, reload: reloadSettings } = useDataLoader<{
    filters: SavedFilter[];
    columnSettings?: ListColumnSettings;
  }>(() => api.settings.getListColumnSettings(entityTypeName.current));
  const { getLead } = useLead(api.lead);
  const leadState = useSelector((state: State) => state.lead);
  const { openModal, modalOpen: requirementModalOpen } = useConfiguration(api);
  const [savedColumns, setSavedColumns] = React.useState<Column[]>([]);
  
  const [columns, setColumns] = useState<JSX.Element[]>(ClientInternalApproval);

  useEffect(() => {
    if (mainTabName === DocumentCopyType.ClientCopy) {
      if (tabName === TabNames.InternalApprovalApproval) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterClientInternal;
        setColumns(ClientInternalApproval);
      } else if (tabName === TabNames.ClientApprovalApproval) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterClientClientApproval;
        setColumns(ClientApproval);
      } else if (tabName === TabNames.signed) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterClientSigned;
        setColumns(ClientSigned);
      } else if (tabName === TabNames.Rejected) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterClientRejected;
        setColumns(ClientRejected);
      } else if (tabName === TabNames.draft) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterClientDraft;
        setColumns(Draft);
      } else {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterClientDraft;
        setColumns(Draft);
      }
    } else {
      if (tabName === TabNames.InternalApprovalApproval) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterLandlordInternal;
        setColumns(LandlordInternalApproval);
      } else if (tabName === TabNames.LandlordApprovalApproval) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterLandlordLandlordApproval;
        setColumns(LandlordApproval);
      } else if (tabName === TabNames.signed) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterLandlordSigned;
        setColumns(LandlordSigned);
      } else if (tabName === TabNames.Rejected) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterLandlordRejected;
        setColumns(LandlordRejected);
      } else if (tabName === TabNames.draft) {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterLandlordDraft;
        setColumns(Draft);
      } else {
        entityTypeName.current = ListEntityType.SpecialApprovalFeeLetterLandlordDraft;
        setColumns(Draft);
      }
    }
    reloadSettings();
  }, [tabName, mainTabName]);

  useEffect(() => {
    const handleFilterOptionsApi = async () => {
      try {
        const propertyTypeData = await api.AddNewRequirement.getPropertyType();
        const subTypes = propertyTypeData.reduce((acc: any, item: any) => {
          acc.push(
            ...item.subTypes.map(
              (subType: { _id: any; propertyTypeName: any }) => ({
                value: subType._id,
                name: decodeHtmlEntities(subType.propertyTypeName),
              })
            )
          );
          return acc;
        }, []);
        setPropertyType(subTypes);
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }

      try {
        const transactionExecutiveData = await api.user.getCrmAgents({
          sortBy: "name",
          sortOrder: SortOrder.ASC,
        })

        const transactionExecutiveOptions = transactionExecutiveData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.name),
        }));
        setTransactionExecutive(transactionExecutiveOptions)
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
      try {
        const userListData = await api.user.getUserList();
        const userListDataOptions = userListData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.name),
        }));
        setUserList(userListDataOptions)
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
    };

    handleFilterOptionsApi()
  }, [])

  const {
    performAction: saveFilter,
    isPerforming: savingFilter,
  } = usePerformAction(
    (fls: Dict<FilterValueType>, name: string) =>
      api.settings.saveFilter(fls, name, entityTypeName.current),
    () => {
      toastr.success("Success", "Filter Saved");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to save filter");
    }
  );

  const { performAction: removeFilter } = usePerformAction(
    (_id: string) => api.settings.removeSavedFilter(_id),
    () => {
      toastr.success("Success", "Filter Removed");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to remove filter");
    }
  );

  const { performAction: saveColumnSettings } = usePerformAction(
    (cols: Column[]) =>
      api.settings.saveListColumnSettings(cols, entityTypeName.current),
    reloadSettings
  );

  const loadFromQuery = () => {
    const queryFilter: QueryFilter = {};
    const queries: ParsedQuery<string> = queryString.parse(params);
    queryFilter.query = queries.query as string;
    if (queries.filters) {
      queryFilter.filters = JSON.parse(queries.filters?.toString());
    }
    if (queries.page) {
      queryFilter.page = Number(queries.page || 1);
    }
    if (queries.perPage) {
      queryFilter.perPage = Number(queries.perPage || 1);
    }
    if (queries.startDate) {
      queryFilter.startDate = moment(queries.startDate as string).toDate();
    }
    if (queries.endDate) {
      queryFilter.endDate = moment(queries.endDate as string).toDate();
    }

    if (queries.sort) {
      queryFilter.sort = JSON.parse(queries.sort?.toString());
    }

    if (queries.listView) {
      queryFilter.listView = queries.listView?.toString();
    }

    return queryFilter;
  }

  const [dateFilters, setDateFilters] = useState<IDateRange | undefined>({
    startDate: loadFromQuery()?.startDate,
    endDate: loadFromQuery()?.endDate,
  });

  const {
    performAction: downloadRmaReport,
    isPerforming: downloading,
  } = usePerformAction(async () => {

    let excelColumns: {
      label: string;
      source?: string;
    }[] = columns
      ?.map((column) => {
        if (columns) {
          const selectedColumn = columns?.find(
            (col) => col?.props?.column === column?.key
          ) as { props: IListTableColumnProps };
          if (selectedColumn && !selectedColumn.props.ignoreOnExcel) {
            return {
              label: selectedColumn?.props?.label || "",
              source:
                selectedColumn?.props?.excelSource ||
                selectedColumn?.props?.source?.toString(),
            };
          }
        }
      })
      .filter((a) => !!a) as {
        label: string;
        source?: string;
      }[];
    if (!excelColumns?.length) {
      const allColumns = columns as { props: IListTableColumnProps }[];
      excelColumns = allColumns
        .filter((col) => col.props.showDefault && !col.props.ignoreOnExcel)
        .map((selectedColumn) => {
          return {
            label: selectedColumn?.props?.label || "",
            source:
              selectedColumn?.props?.excelSource ||
              selectedColumn?.props?.source?.toString(),
          };
        });
    }
  });

  const [sort, setSort] = useState<ListSort>({
    sortBy: loadFromQuery()?.sort?.sortBy || "createdAt",
    sortOrder: loadFromQuery()?.sort?.sortOrder || SortOrder.DESC,
  });

  const [page, setPage] = React.useState(loadFromQuery()?.page || 1);
  const [perPage, setPerPage] = React.useState(loadFromQuery()?.perPage || 20);
  const [requirementId, setRequirementId] = React.useState<string | null>(null);

  const { data, loading, loaded, reload } = useDataLoader<
    PaginatedApiResponse<LeadRequirement> & { lastUpdatedAt: Date }
  >(
    (
      searchTerm: string | undefined,
      searchFilters: Dict<FilterValueType>,
      currentPage: number,
      pageCount: number,
      searchOrder?: ListSort,
      dates?: IDateRange
    ) => {

      const currentFilter = {
        ...getFilters(loadFromQuery()?.filters || searchFilters),
      };

      if (currentFilter.salesStatus?.includes("ConfirmedSale")) {
        currentFilter.salesStatus = [
          ...currentFilter.salesStatus?.filter(
            (x: any) => x !== "ConfirmedSale"
          ),
          "Ordered",
          "OrderConfirmed",
        ];
      }

      return api.proposalDocument.getFeeLetterList({
        ...currentFilter,
        fromDate: dates?.startDate
          ? moment(dates?.startDate).startOf("day").toDate()
          : undefined,
        toDate: dates?.endDate
          ? moment(dates?.endDate).endOf("day").toDate()
          : undefined,
        page: currentPage,
        query: loadFromQuery()?.query || searchTerm,
        sortBy: searchOrder?.sortBy || 'createdAt',
        sortOrder: searchOrder?.sortOrder || SortOrder.DESC,
        perPage: pageCount,
        documentStage : documentStage.FeeConfirmation,
        documentStatus : TabNames.signed === tabName ? 'SignedDocuments' : tabName?.replace(/\s+/g, ''),
        documentCopyType: mainTabName
      });
    },
    [search, filters, page, perPage, tabName, sort, dateFilters, mainTabName]
  );

  useEffect(() => {
    if (loaded) {
      setPage(1);
      onChangeFilter(filters, search, 1, perPage, dateFilters, sort);
      reload(search, filters, 1, perPage, sort, dateFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filters, sort, perPage, dateFilters, tabName, mainTabName]);

  useEffect(() => {
    if (loaded) {
      reload(search, filters, page, perPage, sort, dateFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  React.useEffect(() => {
    const filterResonse = loadFromQuery();

    if (filterResonse.query) {
      setSearch(filterResonse.query as string);
    }

    if (filterResonse.filters) {
      if (
        filterResonse.filters?.autolineStatus &&
        Array.isArray(filterResonse.filters.autolineStatus)
      ) {
        filterResonse.filters.autolineStatus = filterResonse.filters.autolineStatus?.filter(
          (x: any) => x.value !== "PreVin" && x.value !== "Produced"
        );
        if (!filterResonse.filters.autolineStatus?.length) {
          delete filterResonse.filters.autolineStatus;
        }
      }
      setFilters(filterResonse.filters);
    }

    if (filterResonse.page) {
      setPage(filterResonse.page);
    }
    if (filterResonse.perPage) {
      setPerPage(filterResonse.perPage);
    }
  }, []);

  const [selected, setSelected] = useState<string[]>([]);

  const onSaveFilter = (name: string) => {
    saveFilter(filters, name);
  };

  const { data: allPropertyType } = useDataLoader<City[]>(() =>
    api.AddNewRequirement.getPropertyType()
  );


  const onRemoveFilter = (_id: string) => {
    removeFilter(_id);
  };

  const onChangeFilter = (
    searchFilters: Dict<FilterValueType>,
    searchValue: string,
    currentPage: number,
    numberOfPages: number,
    dates?: IDateRange,
    sortOption?: ListSort
  ) => {
    let query = `query=${encodeURIComponent(
      searchValue
    )}&page=${currentPage}&perPage=${numberOfPages}`;

    if (
      getFilters(searchFilters) &&
      Object.keys(getFilters(searchFilters)).length
    ) {
      query =
        query + `&filters=` + encodeURIComponent(JSON.stringify(searchFilters));
    }
    if (dates?.startDate) {
      query =
        query + `&startDate=` + moment(dates?.startDate).format("DD-MMM-YYYY");
    }
    if (dates?.endDate) {
      query =
        query + `&endDate=` + moment(dates?.endDate).format("DD-MMM-YYYY");
    }
    if (sortOption && sortOption.sortBy) {
      query = query + `&sort=` + JSON.stringify(sortOption);
    }
    history.replace(`/fee-letter?${query}`);
  };

  const filterRow = (
    <ListFilters
      key="filter-row"
      savedFilters={leadSettings?.filters || []}
      onSaveFilter={onSaveFilter}
      isSavingFilter={savingFilter}
      onRemoveFilter={onRemoveFilter}
      filters={filters}
      onFilter={(searchFilters: Dict<FilterValueType>) => {
        onChangeFilter(searchFilters, search, page, perPage, dateFilters, sort);
        setFilters(searchFilters);
      }}
    >
      <MultiSelectFilter
        label="Lead Intent"
        filterKey="leadIntent"
        key="leadIntent"
        allowSearch
        options={masterData.data?.leadIntents || []}
        valueField="_id"
        labelField="name"
      />
      {/* <MultiSelectFilter
        label="Lead Type"
        filterKey="leadType"
        key="leadType"
        allowSearch
        options={masterData.data?.leadTypes || []}
        valueField="_id"
        labelField="name"
      /> */}
      <MultiSelectFilter
        label="Created By"
        filterKey="createdBy"
        key="createdBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Approved By"
        filterKey="approvedBy"
        key="approvedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Rejected By"
        filterKey="rejectedBy"
        key="rejectedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Uploaded By"
        filterKey="uploadedBy"
        key="uploadedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilterWithApiSearch
        label="Company"
        filterKey="companyIds"
        key="company"
        allowSearch
        loadData={async (query) => {
          const response = await api.company.searchCompanyInline({ query }) as any ;
          return [...response?.tenants];
        }}
        removeUnassigned
      />,
      <SingleSelectFilter
        label="Property Type"
        filterKey={"propertyTypeKey"}
        key={"name"}
        allowSearch
        options={
          allPropertyType?.reduce((acc: any, item: any) => {
            acc.push(
              ...item.subTypes.map(
                (subType: { propertyTypeKey: any; propertyTypeName: any }) => ({
                  value: subType.propertyTypeKey,
                  name: decodeHtmlEntities(subType.propertyTypeName),
                })
              )
            );
            return acc;
          }, []) || []
        }
        valueField="value"
        labelField="name"
      />
    </ListFilters>
  );

  const headerActions = [
    <ListHeaderSearch
      placeholder="Customer Name, Lead Title, Company Name"
      serachTerm={search}
      onSearch={(val: string) => {
        onChangeFilter(filters, val, page, perPage, dateFilters, sort);
        setSearch(val);
      }}
    />,
    <DateRangeListFilter
      default={dateFilters}
      onChange={(d?: IDateRange) => {
        setDateFilters({
          startDate: d?.startDate,
          endDate: d?.endDate,
        });
        if (loaded) {
          onChangeFilter(
            filters,
            search,
            page,
            perPage,
            {
              startDate: d?.startDate,
              endDate: d?.endDate,
            },
            sort
          );
        }
      }}
    />,
  ];

  const {
    data: proposalDocuments,
    reload: reloadProposalDocument,
  } = useDataLoader<any[]>(
    (rid: string) =>
      rid ? api.proposalDocument.listProposalDocumentStages(rid!) : undefined,
    [viewFeeLetterModal.masterRequirementId]
  );

  useEffect(() => {
    reloadProposalDocument(viewFeeLetterModal.masterRequirementId)
  }, [viewFeeLetterModal.masterRequirementId])

  const onFeeLetterClick = (feeletter: any) => {
    setViewFeeLetterModal({ isOpen: true, 
      id: feeletter._id,
      leadId: feeletter.leadDetails._id,
      isSigned: false,
     title : 'Term sheet',
     masterRequirementId : feeletter.proposedPropertyDetails[0].masterRequirementId,
    //  stage: ''
     })
    // history.push(`${RouteKeys.FeeLetter.replace(":id", id)}`);
  };
  
  const formatData = (feeletters: any[]) =>{
    if(mainTabName === DocumentCopyType.ClientCopy){
      return feeletters
    }else{
      return feeletters?.map(item=>({ ...item, document: item.seperateDocumentForLandlord}))
    }
  }

  return (
    <AppLayout>
      <>
        <ListHeader additionalRows={[filterRow]} actions={headerActions}>
          <div className="d-flex align-items-center">
            <h2 className="m-0 d-flex align-items-baseline flex-column">
              Fee Letter
              {data && (
                <span className="font-xs text-muted font-weight-semibold d-block ml-2 pt-2">
                  {data.count} Total
                  <span className="font-weight-normal ml-1">
                    Updated <Moment fromNow date={data.lastUpdatedAt} />
                  </span>
                  {selected.length > 0 && (
                    <span className="font-weight-normal ml-1">
                      Selected {selected.length} items
                    </span>
                  )}
                </span>
              )}
            </h2>
            <div className="view-switch ml-lg-5 ml-md-4 ml-auto pl-3 d-flex">
              <div className="border rounded-sm d-flex font-normal"></div>
            </div>
          </div>
        </ListHeader>
        <MainTabs
          tabs={[
            { key: 'client', value: DocumentCopyType.ClientCopy  },
            { key: 'landlord', value: DocumentCopyType.LandlordCopy },
          ]}
          tabChangeHandler={(tb: PaidBy | DocumentCopyType) => {
            setMainTabName(tb);
          }}
          tabName={mainTabName}
        />
          <span className="border-top"></span>
          <Tabs
          tabs={mainTabName === DocumentCopyType.ClientCopy ? [
            { name: TabNames.draft, },
            { name: TabNames.InternalApprovalApproval, },
            { name: TabNames.ClientApprovalApproval, },
            { name: TabNames.signed, },
            { name: TabNames.Rejected, },
          ] : [
            { name: TabNames.draft, },
            { name: TabNames.InternalApprovalApproval, },
            { name: TabNames.LandlordApprovalApproval, },
            { name: TabNames.signed, },
            { name: TabNames.Rejected, },
          ]}
          tabChangeHandler={(tb: TabNames) => {
            setTabName(tb);
          }}
          tabName={tabName}
        />
        <>
          {(!loaded || loading) && (
            <ContainerLoader
              height={window.innerHeight - 300}
            ></ContainerLoader>
          )}
          {loaded && !loading && (
            <ListTable
              // data={getDataByTabNames(data?.data, tabName)}
              data={formatData(data?.data)}
              showColumnSettings
              // selectedValues={selected}
              // currentCoulumns={
              //   columns?.length
              //     ? columns?.map((item) => item?.props?.column)
              //     : []
              // }
              // onSelect={setSelected}
              onSort={(sortKey: string, sortOrder?: SortOrder) => {
                setSort({ sortBy: sortKey, sortOrder });
                onChangeFilter(filters, search, page, perPage, dateFilters, {
                  sortBy: sortKey,
                  sortOrder,
                });
              }}
              sort={sort}
              trProps={(d: LeadRequirement) => {
                return {
                  className: classnames({
                    "cursor-pointer": true,
                  }),
                  onClick: () => {
                    onFeeLetterClick(d);
                  },
                };
              }}
              selectedColumns={leadSettings?.columnSettings?.columns}
              onColumnSettingsSaved={saveColumnSettings}
            >
              {columns}
            </ListTable>
          )}
          <Pagination
            currentPage={page}
            totalPages={data?.totalPages}
            onPageChange={(pg: number) => {
              setPage(pg);
              onChangeFilter(filters, search, pg, perPage, dateFilters, sort);
            }}
            perPage={perPage}
            onPerPageChange={(pg: number) => {
              setPerPage(pg);
              onChangeFilter(filters, search, page, pg, dateFilters, sort);
            }}
            count={data?.count}
            label="Fee Letter"
          />
          {requirementModalOpen && leadState?.leadDetails && requirementId && (
            <Requirement
              leads={[leadState?.leadDetails]}
              customer={leadState?.leadDetails?.customer}
              reload={() => {
                getLead(leadState?.leadDetails?._id!);
              }}
            ></Requirement>
          )}
        </>
      {viewFeeLetterModal?.isOpen && (
        <UploadFeeDocument
          showAcceptButton={canApproveFeeLetter}
          showRejectButton={canRejectFeeLetter}
          reload={() => {
            reloadProposalDocument(viewFeeLetterModal.masterRequirementId)
            reload(search, filters, 1, perPage, sort, dateFilters);
          }}
          onClose={() => {
            setViewFeeLetterModal({});
            reload(search, filters, 1, perPage, sort, dateFilters);
          }}
          documentId={viewFeeLetterModal.id!}
          proposalDocuments={proposalDocuments?.filter(
            (x) =>
              x.proposedPropertyDetails[0]?.masterRequirementId ===
            viewFeeLetterModal.masterRequirementId
          ) || []}
          isSigned={viewFeeLetterModal.isSigned}
          title={"Fee Confirmation"}
          leadId={viewFeeLetterModal.leadId}
          defaultTab={
            mainTabName === DocumentCopyType.LandlordCopy
              ? FeeConfirmationTabNames.LandLordFeeConfirmation
              : FeeConfirmationTabNames.ClientFeeConfirmation
          }
        ></UploadFeeDocument>
      )}
      </>
    </AppLayout>
  );
};

export default FeeLetterList;
